import React from 'react';
import { useHistory } from 'react-router-dom';

import Label from '../../../components/Label';
import List from '../../../components/List';
import NavTabs from '../../../components/NavTabs';

import { Container, Grid, Button } from '@material-ui/core/';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

import EventApi from '../../../services/event';

import {
    ContainerBox,
    Content,
    Row,
    Align,
} from './styles';

const Confirm = ({ prevStep, values }) => {
    const history = useHistory();

    const columns = [
        { field: 'value', title: 'Nome' },
        { field: 'line', title: 'Linha' },
        { field: 'column', title: 'Coluna' },
    ];

    function getPositions() {
        const positions = []
        values.rows.forEach(
            (row, index_row) => row.forEach(
                (col, index_col) => {
                    if (col.isSelected) positions.push({
                        value: col.name,
                        column: `${index_col}`,
                        line: `${index_row}`,
                        enable: true,
                        full: false,
                        event_id: 0
                    })
                }
            )
        )
        console.log(positions)
        return positions
    }

    const data = [
        {
            name: 'Posições Ativas',
            content: (<List columns={columns} rows={[]} getRows={getPositions()} actions={[]}/>)
        }
    ]

    const storage = () => {
        console.log(format(zonedTimeToUtc(
            format(values.start_at, `yyyy-MM-dd ${values.start_hour}:00}`),
            'America/Sao_Paulo'
        ), `yyyy-MM-dd ${values.start_hour}:00`))

        const positions = getPositions()

        EventApi.createEvent({
            name: values.name,
            description: values.description,
            address: values.address,
            cep: values.cep.match(/\d/g).join(""),
            phone: values.phone.match(/\d/g).join(""),
            lines: values.count_rows,
            columns: values.count_columns,
            start_at: format(zonedTimeToUtc(
                format(values.start_at, `yyyy-MM-dd ${values.start_hour}:00}`),
                'America/Sao_Paulo'
            ), `yyyy-MM-dd ${values.start_hour}:00`),
            finish_at: format(zonedTimeToUtc(
                format(values.finish_at, `yyyy-MM-dd ${values.finish_hour}:00}`),
                'America/Sao_Paulo'
            ), `yyyy-MM-dd ${values.finish_hour}:00`),
            qrcode: null,
            enable: true,
        })
        .then(resp => {
            if (!!resp.data) {
                if (positions.length) {
                    console.log(resp.data.id)
                    EventApi.createBulkPosition(positions.map(item => { item.event_id = resp.data.id; return item }))
                    .then(resp => {
                        if (!!resp.data) history.push("/events");
                    })
                    .catch(function(error) {
                        toast.error(error)
                    });
                } else history.push("/events");
            }
        })
        .catch(function(error) {
            toast.error(error)
        });
    };

    return (
        <ContainerBox>
            <Content>
                <Container className="container" maxWidth="md">
                    <Row>
                        <Container className="container" maxWidth="md">
                        <Label
                            size='big'
                            color='dark'
                            align='center'
                            font='Roboto'
                            padding='10px 0 30px'
                        >Confimação de Dados</Label>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        nome: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.name}
                                    </Label>
                                </Align>
                            </Grid>
                            <Grid item md={6}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        telefone: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.phone}
                                    </Label>
                                </Align>
                            </Grid>
                        </Grid>

                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        endereço: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.address}
                                    </Label>
                                </Align>
                            </Grid>
                            <Grid item md={6}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        cep: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.cep}
                                    </Label>
                                </Align>
                            </Grid>
                        </Grid>

                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        linhas: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.count_rows}
                                    </Label>
                                </Align>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        colunas: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.count_columns}
                                    </Label>
                                </Align>
                            </Grid>
                            <Grid item md={6}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        data de início: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {format(zonedTimeToUtc(
                                            format(values.start_at, `yyyy-MM-dd ${values.start_hour}:00}`),
                                            'America/Sao_Paulo'
                                        ), `yyyy-MM-dd ${values.start_hour}:00`)}
                                    </Label>
                                </Align>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        data de término: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {format(zonedTimeToUtc(
                                            format(values.finish_at, `yyyy-MM-dd ${values.finish_hour}:00}`),
                                            'America/Sao_Paulo'
                                        ), `yyyy-MM-dd ${values.finish_hour}:00`)}
                                    </Label>
                                </Align>
                            </Grid>
                        </Grid>

                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={12}>
                                <Align>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        weight='700'
                                        padding='10px 5px'
                                    >
                                        descrição: 
                                    </Label>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                        padding='10px 5px'
                                    >
                                        {values.description}
                                    </Label>
                                </Align>
                            </Grid>
                        </Grid>

                        <Label
                            size='nano'
                            color='dark'
                            align='left'
                            padding='10px 5px'
                        >
                            <Container maxWidth="xs" style={{ maxWidth: '80%' }}>
                                <NavTabs itens={data} />
                            </Container>
                        </Label>
                        </Container>
                    </Row>
                </Container>
                <div>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={prevStep}
                    >anterior</Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={storage}
                    >salvar</Button>
                </div>
            </Content>
        </ContainerBox>
    )
}

export default Confirm;
